/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLayoutAlignRight = createReactComponent(
  "layout-align-right",
  "IconLayoutAlignRight",
  [
    ["path", { d: "M20 4l0 16", key: "svg-0" }],
    [
      "path",
      {
        d: "M4 9m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z",
        key: "svg-1"
      }
    ]
  ]
);

export { IconLayoutAlignRight as default };
//# sourceMappingURL=IconLayoutAlignRight.js.map
